import { createSvgIcon } from "@mui/material";

export const ReframeIcon = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M2.62207 15.75C2.93296 15.7501 3.24414 16.0626 3.24414 16.375V17.3125C3.24414 18.5233 4.21523 19.4997 5.41992 19.5H6.35352C6.66437 19.5002 6.97559 19.8126 6.97559 20.125C6.97558 20.4765 6.66437 20.7498 6.35352 20.75H5.41992C3.51561 20.7497 2 19.2264 2 17.3125V16.375C2 16.0625 2.27226 15.75 2.62207 15.75Z"
      fill="currentColor"
    />
    <path
      d="M15.1592 19.5C15.7686 19.5 15.7812 19.8125 15.7812 20.125C15.7812 20.4766 15.7686 20.75 15.1592 20.75H8.84082C8.49101 20.75 8.21875 20.4766 8.21875 20.125C8.21875 19.8125 8.49101 19.5 8.84082 19.5H15.1592Z"
      fill="currentColor"
    />
    <path
      d="M21.3779 15.75C21.6889 15.75 22 16.0625 22 16.375V17.3125C22 19.2264 20.4455 20.7497 18.5801 20.75H17.6465C17.2968 20.7499 17.0244 20.4765 17.0244 20.125C17.0244 19.8126 17.2968 19.5002 17.6465 19.5H18.5801C19.7459 19.4997 20.7559 18.5233 20.7559 17.3125V16.375C20.7559 16.0626 21.0282 15.7501 21.3779 15.75Z"
      fill="currentColor"
    />
    <path
      d="M14.6016 8.44824C14.8374 8.21278 15.2397 8.19884 15.4893 8.44824L18.5967 11.5557C18.8325 11.7915 18.8325 12.2085 18.5967 12.4443L15.4893 15.5518C15.2397 15.8012 14.8374 15.7872 14.6016 15.5518C14.3519 15.3021 14.3519 14.9128 14.6016 14.6631L16.627 12.6377L12 12.626L7.37305 12.6377L9.39844 14.6631C9.64814 14.9128 9.64814 15.3021 9.39844 15.5518C9.16262 15.7872 8.76034 15.8012 8.51074 15.5518L5.40332 12.4443C5.16749 12.2085 5.16749 11.7915 5.40332 11.5557L8.51074 8.44824C8.76034 8.19884 9.16262 8.21279 9.39844 8.44824C9.64814 8.69794 9.64814 9.08721 9.39844 9.33691L7.37305 11.3623L12 11.373L16.627 11.3623L14.6016 9.33691C14.3519 9.08721 14.3519 8.69794 14.6016 8.44824Z"
      fill="currentColor"
    />
    <path
      d="M2.62207 9.5C2.93296 9.50012 3.24414 9.81256 3.24414 10.125V13.875C3.24414 14.2265 2.93296 14.4999 2.62207 14.5C2.27226 14.5 2 14.2266 2 13.875V10.125C2 9.8125 2.27226 9.5 2.62207 9.5Z"
      fill="currentColor"
    />
    <path
      d="M21.3779 9.5C21.6889 9.5 22 9.8125 22 10.125V13.875C22 14.2266 21.6889 14.5 21.3779 14.5C21.0282 14.4999 20.7559 14.2265 20.7559 13.875V10.125C20.7559 9.81255 21.0282 9.50011 21.3779 9.5Z"
      fill="currentColor"
    />
    <path
      d="M6.35352 3.25C6.66437 3.25019 6.97559 3.56259 6.97559 3.875C6.97559 4.22646 6.66437 4.49983 6.35352 4.5H5.41992C4.21523 4.50027 3.24414 5.51578 3.24414 6.6875V7.625C3.24414 7.97649 2.93296 8.24989 2.62207 8.25C2.27226 8.25 2 7.97656 2 7.625V6.6875C2 4.81266 3.51561 3.25026 5.41992 3.25H6.35352Z"
      fill="currentColor"
    />
    <path
      d="M18.5801 3.25C20.4455 3.25027 22 4.81266 22 6.6875V7.625C22 7.97656 21.6889 8.25 21.3779 8.25C21.0282 8.24991 20.7559 7.9765 20.7559 7.625V6.6875C20.7559 5.51578 19.7459 4.50028 18.5801 4.5H17.6465C17.2968 4.49985 17.0244 4.22647 17.0244 3.875C17.0244 3.56258 17.2968 3.25017 17.6465 3.25H18.5801Z"
      fill="currentColor"
    />
    <path
      d="M15.1592 3.25C15.7686 3.25 15.7812 3.5625 15.7812 3.875C15.7812 4.22656 15.7686 4.5 15.1592 4.5H8.84082C8.49101 4.5 8.21875 4.22656 8.21875 3.875C8.21875 3.5625 8.49101 3.25 8.84082 3.25H15.1592Z"
      fill="currentColor"
    />
  </svg>,
  "ReframeIcon",
);
